import { SuspenseWithFallback } from 'shared/ui'

export const wrapInSuspense = (element: React.ReactNode) => (
  <SuspenseWithFallback>{element}</SuspenseWithFallback>
)
